import React, {useEffect} from 'react';
import {usePhaseState} from 'funnel-schedule/phase-context';
import ImmunitySalesIndex from './join';
import track from 'utils/track';

export default function () {
  const {
    phases: {
      immunity: immunitySchedule = {
        phase: '',
        salesEnd: ''
      }
    }
  } = usePhaseState();

  useEffect(() => {
    track('Product Viewed', {
      product_id: 'B-IHC',
      sku: 'B-IHC',
      name: 'Immune Health Collection',
      variant: immunitySchedule.phase === 'during' ? 'ihc21-special' : 'ihc21',
      value: immunitySchedule.phase === 'during' ? 47 : 97,
      currency: 'usd'
    });
  }, [immunitySchedule.phase]);

  return (
    <ImmunitySalesIndex
      ctaOverride={immunitySchedule.phase === 'during' ? 'salesPrice' : 'fullPrice'}
      shareUrl="https://health.foodrevolution.org/immunity/join-special/"
    />
  );
}
